import getStringValuesArray from '@/utils/array/getStringValuesArray'

export function prepareFormDataJoin (data, keys, byKey = 'id') {
  const prepareFormData = {
    ...data
  }

  for (const key of keys) {
    if (key in prepareFormData) {
      if (!prepareFormData[key]?.length) continue

      prepareFormData[key] = getStringValuesArray(prepareFormData[key], byKey)
    }
  }

  return prepareFormData
}
